<app-header-global></app-header-global>

<div class="row allcontent">
  <div [ngClass]="sidebarCollapsed ? 'col-sm-1' : 'col-sm-2'">
    <app-side-overlay-menu></app-side-overlay-menu>
  </div>
  <div [ngClass]="sidebarCollapsed ? 'col-sm-11' : 'col-sm-10'" class="contentsection">
    <main class="document-viewer">
      <header class="viewer-toolbar">
        <div class="toolbar-leading">
          <button type="button" class="toolbar-button back-button" (click)="goBack()" [attr.aria-label]="'Back to ' + sourcePageTitle" [title]="'Back to ' + sourcePageTitle">
            <img src="assets/images/arrow_back.svg" class="toolbar-icon back-icon" alt="">
          </button>
          <span class="header-file-name" [title]="fileName">{{ fileName }}</span>
        </div>
        <button type="button" class="toolbar-button download-button" (click)="downloadFile()" [disabled]="!hasFile" aria-label="Download file" title="Download file">
          <img src="assets/images/file_download.svg" class="toolbar-icon download-icon" alt="">
          <span>Download File</span>
        </button>
      </header>

      <div class="viewer-content">
        <section class="preview-panel" aria-live="polite">
          <div class="document-placeholder">
            <p *ngIf="isLoading" class="viewer-message">Loading document...</p>
            <p *ngIf="errorMessage" class="viewer-message error-message">{{ errorMessage }}</p>
            <iframe *ngIf="previewType === 'pdf' && pdfUrl" [src]="pdfUrl" [title]="fileName" class="pdf-frame"></iframe>
            <img *ngIf="previewType === 'image' && pdfUrl" [src]="pdfUrl" [alt]="fileName" class="image-preview">
            <div *ngIf="previewType === 'spreadsheet'" class="spreadsheet-preview">
              <div *ngIf="spreadsheetSheets.length; else emptyWorkbook" class="spreadsheet-workbook">
                <div class="spreadsheet-tabs" role="tablist" aria-label="Worksheets">
                  <button
                    *ngFor="let sheet of spreadsheetSheets; let sheetIndex = index"
                    type="button"
                    role="tab"
                    class="spreadsheet-tab"
                    [class.selected]="selectedSheetIndex === sheetIndex"
                    [attr.aria-selected]="selectedSheetIndex === sheetIndex"
                    (click)="selectedSheetIndex = sheetIndex">
                    {{ sheet.name }}
                  </button>
                </div>
                <div class="spreadsheet-grid-scroll" *ngIf="spreadsheetSheets[selectedSheetIndex] as sheet">
                  <table class="spreadsheet-grid">
                    <colgroup>
                      <col class="row-number-column">
                      <col *ngFor="let width of sheet.columnWidths" [style.width.px]="width">
                    </colgroup>
                    <thead>
                      <tr>
                        <th class="spreadsheet-corner"></th>
                        <th *ngFor="let label of sheet.columnLabels" class="spreadsheet-column-heading">{{ label }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of sheet.rows; let rowIndex = index">
                        <th class="spreadsheet-row-heading">{{ sheet.rowLabels[rowIndex] }}</th>
                        <ng-container *ngFor="let cell of row">
                          <td *ngIf="cell" [attr.rowspan]="cell.rowSpan || null" [attr.colspan]="cell.colSpan || null">{{ cell.value }}</td>
                        </ng-container>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <ng-template #emptyWorkbook><p class="viewer-message">No worksheet content found.</p></ng-template>
            </div>
            <div #docxContainer class="docx-preview" [hidden]="previewType !== 'docx'"></div>
            <div *ngIf="previewType === 'unsupported' && !isLoading && !errorMessage" class="viewer-message">
              Preview is not available for this file type. Download the file to open it.
            </div>
          </div>
        </section>

      </div>
    </main>
  </div>
</div>